"use strict";

var _preact = require("preact");

module.exports = _ref => {
  let {
    currentDeviceId,
    audioSources,
    onChangeSource
  } = _ref;
  return (0, _preact.h)("div", {
    className: "uppy-Audio-videoSource"
  }, (0, _preact.h)("select", {
    className: "uppy-u-reset uppy-Audio-audioSource-select",
    onChange: event => {
      onChangeSource(event.target.value);
    }
  }, audioSources.map(audioSource => (0, _preact.h)("option", {
    key: audioSource.deviceId,
    value: audioSource.deviceId,
    selected: audioSource.deviceId === currentDeviceId
  }, audioSource.label))));
};